import { render, staticRenderFns } from "./form2.vue?vue&type=template&id=6b4f9ac6&scoped=true"
import script from "./form2.vue?vue&type=script&lang=js"
export * from "./form2.vue?vue&type=script&lang=js"
import style0 from "./form2.vue?vue&type=style&index=0&id=6b4f9ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4f9ac6",
  null
  
)

export default component.exports